module.exports = __webpack_public_path__ + "static/media/p3.7ded283e.mp4";